import script from "./LearningHub.vue?vue&type=script&setup=true&lang=js"
export * from "./LearningHub.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__